/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_Empty_HintInputs */

const cs_settings_teams_empty_hint = /** @type {(inputs: Settings_Teams_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte tým, určete vedoucího a přidejte makléře. Rozsah kalendáře TÝM se řídí členstvím.`)
};

const en_settings_teams_empty_hint = /** @type {(inputs: Settings_Teams_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a team, name a leader, then add brokers. Calendar TEAM scope follows membership.`)
};

/**
* | output |
* | --- |
* | "Create a team, name a leader, then add brokers. Calendar TEAM scope follows membership." |
*
* @param {Settings_Teams_Empty_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_empty_hint = /** @type {((inputs?: Settings_Teams_Empty_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_Empty_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_empty_hint(inputs)
	return cs_settings_teams_empty_hint(inputs)
});